import { ApiRoutes } from '../helpers/routes'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/passwordRecover`

class RecoverPasswordService {
    forgotPassword = async (email: string) => {
        const params = new URLSearchParams({
            email: email,
        })
        return fetchApi(`${baseUrl}${ApiRoutes.recoverPassword.forgot}?${params.toString()}`, {
            method: 'POST',
        })
    }

    resetPassword = async (email: string, code: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.recoverPassword.check}`, {
            method: 'POST',
            body: JSON.stringify({ email, token: code }),
        })
    }

    updatePassword = async (email: string, code: string, newPassword: string) => {
        return fetchApi(`${baseUrl}`, {
            method: 'PATCH',
            body: JSON.stringify({ email, token: code, newPassword }),
        })
    }

    activateUser = async (token: string) => {
        const params = new URLSearchParams({
            token: token,
        })
        return fetchApi(`${baseUrl}${ApiRoutes.recoverPassword.activate}?${params.toString()}`, {
            method: 'POST',
        })
    }
}

export default RecoverPasswordService
